module.exports = __webpack_public_path__ + "img/youtube-intro.8c57514d.webp";